import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';
import {
    Media
} from '../store';

export interface PropsFromState {
    postRows: Media[][]
}

export interface PropsFromDispatch {
}

class PostList extends Component<PropsFromState & PropsFromDispatch, any> {

    constructor(props: PropsFromState & PropsFromDispatch) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
    }

    render() {

        const {
            postRows
        } = this.props;
        const imgProxy = "http://165.227.131.254:8080/260x260/"

        // render photo grid
        const photoGrid = postRows.map(
            (postRow, rowIndex) => {
                const columns = postRow.map(
                    (post) => {

                        const link = "/composer/media/preview/" + post.url
                        const photoSrc = imgProxy + post.url

                        return (
                            <div key={post.url} className="dtc tc pa1">
                                <Link to={link}>
                                    <img src={photoSrc} />
                                </Link>
                            </div>
                        )
                    });
                return (
                    <div key={rowIndex} className="dt dt--fixed">
                        {columns}
                    </div>
                )
            });

        return (
            <div>
                <h1>Add Media</h1>

                <nav className="tc mv1 center">
                    <Link
                        className="f6 f5-l link black b bg-lightest-blue dib pa3"
                        to="/composer/media/gallery">
                        Gallery
                    </Link>
                    <a className="f6 f5-l link black-80 hover-bg-lightest-blue dib pa3" href="#" title="Home">Device</a>
                </nav>

                <div>
                    {photoGrid}
                </div>

                <form onSubmit={this.handleSubmit}>

                    <input
                        type="submit"
                        value="Load More"
                        className="input-reset pa2 w-100 mt1"
                    />

                </form>
            </div>
        );
    }
}

export default PostList;
